var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h3',[_vm._v(_vm._s(_vm.obj.title))]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',[_vm._v("发布者："+_vm._s(_vm.obj.org_name))]),_vm._v(" "),_c('p',[_vm._v("发布日期："+_vm._s(_vm.timeTrans(_vm.obj.createtime)))])]),_vm._v(" "),_c('div',{staticClass:"main",domProps:{"innerHTML":_vm._s(_vm.obj.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0239780e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/policydetail.vue
// module id = null
// module chunks = 